import script from "./DataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=d9147ef0&scoped=true&lang=css"
import "./DataTable.vue?vue&type=style&index=1&id=d9147ef0&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9147ef0"]])

export default __exports__